export const NO_IMAGE_AVAILABLE_ID = 'bb_brandless_no_image_available_thumbnail'

export const PARTNERSHIP_LOGO_ASPECT_RATIO = 330 / 235
